import React, { FC } from "react";
import { COLOR_BLACK } from "../colors";
import { IconType } from "./types";

export const CheckIcon: FC<IconType> = ({ color = COLOR_BLACK }) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path
      d="M9 16.2L5.5 12.7C5.11 12.31 4.49 12.31 4.1 12.7C3.71 13.09 3.71 13.71 4.1 14.1L8.29 18.29C8.68 18.68 9.31 18.68 9.7 18.29L20.3 7.7C20.69 7.31 20.69 6.69 20.3 6.3C19.91 5.91 19.29 5.91 18.9 6.3L9 16.2Z"
      fill={color}
    />
  </svg>
);
